import { create } from "zustand";
import { AddressItem } from "../services/GeocodeService";

export interface IRouteLocationActions {
    setFrom: (addressItem: AddressItem) => void;
    setTo: (addressItem: AddressItem) => void;
    clearFrom: () => void;
    clearTo: () => void;
    clearViaPoints: () => void;
    addViaPoint: (addressItem: AddressItem) => void;
    addViaPoints: (addressItems: Array<AddressItem>) => void;
    removeViaPoint: (addressItem: AddressItem) => void;
    addBarrierPoint: (addressItem: AddressItem) => void;
    addBarrierPoints: (addressItems: Array<AddressItem>) => void;
    removeBarrierPoint: (addressItem: AddressItem) => void;
}

export interface IRouteLocationState {
    fromAddress: AddressItem | null;
    toAddress: AddressItem | null;
    viaPoints: Array<AddressItem>;
    barrierPoints: Array<AddressItem>;
    actions: IRouteLocationActions;
}

const useRouteLocationStore = create<IRouteLocationState>( (set) => ({
    fromAddress: null,
    toAddress: null,
    viaPoints: new Array<AddressItem>(),
    barrierPoints: new Array<AddressItem>(),
    actions: {
        setFrom: (address:AddressItem) => {         
            set({ fromAddress:address }) 
        },
        setTo: (address:AddressItem) => {
            set({ toAddress: address })
        },
        clearFrom: () => {
            set({ fromAddress: null })
        },
        clearTo: () => {
            set({ toAddress: null })
        },
        clearViaPoints: () => {
            set({viaPoints: []})
        },
        addViaPoint: (addressItem: AddressItem) => {
            set( (state) => ({
                viaPoints: [
                    ...state.viaPoints,
                    addressItem
                ]
            }))
        },
        addViaPoints: (addressItems: Array<AddressItem>) => {
            set( (state) => ({
                viaPoints: [
                    ...state.viaPoints,
                    ...addressItems
                ]
            }))
        },
        removeViaPoint: (addressItem:AddressItem) => {
            set( (state) => ({
                viaPoints: state.viaPoints.filter( viaPoint => viaPoint.name !== addressItem.name )
            }))
        },
        addBarrierPoint: (addressItem:AddressItem) => {
            set( (state) => ({
                barrierPoints: [
                    ...state.barrierPoints,
                    addressItem
                ]
            }))
        },
        addBarrierPoints: (addressItems: Array<AddressItem>) => {
            set( (state) => ({
                barrierPoints: [
                    ...state.barrierPoints,
                    ...addressItems
                ]
            }))
        },
        removeBarrierPoint: (addressItem:AddressItem) => {
            set( (state) => ({
                barrierPoints: state.barrierPoints.filter( barrier => barrier.name !== addressItem.name )
            }))
        }
    }
}));

export const useFromAddress = () => useRouteLocationStore((state) => state.fromAddress);
export const useToAddress = () => useRouteLocationStore((state) => state.toAddress);
export const useViaPoints = () => useRouteLocationStore((state) => state.viaPoints);
export const useBarrierPoints = () => useRouteLocationStore((state) => state.barrierPoints);
export const useRouteLocationActions = () => useRouteLocationStore((state) => state.actions);